<template>
  <div id="search_page_outer" class="container"  style="padding-left: 0;padding-right: 0;">
    <div id="top_search_outer">
      <input type="text"
             placeholder="请输入关键字"
             id="search_top_input"
             v-model="tempText"
             @keyup.enter="searchButtonClicked"
      >
      <a
        href="javascript:void(null);"
        id="top_search_button" class="iconfont"
        @click="searchButtonClicked"
      >
        &#xe615;
      </a>
    </div>

    <div id="search_content_outer">
      <div id="search_date_selector_outer">
        <a
          v-for="(item, index) in dateFilterList"
            href="javascript:void(null);"
           :class="[dateIndex == index ? 'active' : '']"
            @click="dateFilterMenuClicked(index)"
           >{{item.title}}</a>
      </div>
      <div id="search_type_selector_outer">
        <a href="javascript:void(null);"
           v-for="(item, index) in typeFilterList"
           @click="typMenuClicked(index)"
           :class="[ typeIndex == index ? 'active' : '',]">{{item.title}}</a>
      </div>

      <div id="search_result_outer" class="col-xs-12" v-if="searchModel != null">
        <ul class="list-group" v-if="userList.length > 0 || activityList.length > 0">
          <li class="list-group-item" >
            <div style="padding: 0" class="row">
              <div class="col-xs-12 col-sm-6" v-for="(item, index) in userList" :key="'search_page_user_' + index" style="margin-top: 15px;">
                <a class="search-user-outer" :href="userItemSrc(item)" target="_blank" style="text-decoration: none;" v-if="item.isMember == 1">
                  <div class="search-item-user">
                    <div class="user-header" style="background-color:white;">
                      <img :src="userHeadIcon(item)">
                    </div>
                    <div  class="user-content" >
                      <div v-html="filterSearchText((item.name == null || item.name.length == 0) ? item.nickname : item.name)"></div>
                      <div><span>{{item.typeName}}</span><span style="margin-left: 15px;">协会会员</span></div>
                    </div>
                  </div>
                </a>
                <a href="javascript:void(null);" style="text-decoration: none;" v-else>
                  <div class="search-item-user" style="background-color: white;border: solid 1px #fc1a34;" >
                    <div class="user-header" style="border: solid 1px #fc1a34;">
                      <img :src="userHeadIcon(item)">
                    </div>
                    <div  class="user-content" >
                      <div style="color: #333;" v-html="filterSearchText((item.name == null || item.name.length == 0) ? item.nickname : item.name)"></div>
                      <div style="color: #333;"><span>{{item.typeName}}</span></div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </li>

          <li class="list-group-item" v-for="(item, index) in activityList" :key="'search_page_activity_' + index">
            <a :href="itemSrc(item)" style="text-decoration: none;" target="_blank">
              <div class="search-item-info" >
                <span v-html="filterSearchText(item.actionTitle)"></span>
                <span style="color:#999;">{{itemDate(item)}}</span>
              </div>
            </a>
          </li>
        </ul>
        <div v-else style="min-height: 400px; padding-top: 200px;font-size: 1.5rem;color: #666;text-align: center;">
          暂无匹配结果
        </div>
        <div id="search_result_bottom_paginator" style="text-align: right">
          <a href="javascript:void(null);" @click="leftButtonClicked" class="iconfont">&#xe663;</a>
          <span><a href="javascript:void(null);" @click="pageButtonClicked" >{{pageIndex}}</a>/{{totalPage}}</span>
          <a href="javascript:void(null);" @click="rightButtonClicked" class="iconfont">&#xe611;</a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import GroupGoldDefaultHeadIcon from '../assets/shl_group_head_portrait_gold_default.png';
  import GroupRedDefaultHeadIcon from '../assets/shl_group_head_portrait_red_default.png';
  import PersonGoldDefaultHeadIcon from '../assets/shl_personal_head_portrait_gold_default.png';
  import PersonRedDefaultHeadIcon from '../assets/shl_personal_head_portrait_red_default.png';
  import GlobalInstance from "../js/shba";

export default {
  name: "SearchPage",
  data() {
    return {
      title: '搜索页面',
      dateFilterList: [
        {
          title: '不限制日期',
          duration: 'ALL',
        },
        {
          title: '最近一周内',
          duration: 'WEEK',
        },
        {
          title: '最近一月内',
          duration: 'MONTH',
        },
        {
          title: '最近半年内',
          duration: 'YEAR',
        },
      ],
      typeFilterList: [
        {
          title: '全部',
          tag: 0,
        },
        {
          title: '官方消息',
          tag: 4,
        },
        {
          title: '最新动态',
          tag: 1,
        },

        {
          title: '精彩视频',
          tag: 2,
        },
        {
          title: '精彩图集',
          tag: 3,
        },
        {
          title: '相关人员',
          tag: -1,
        },
        {
          title: '相关机构',
          tag: -2,
        },
      ],

      dateIndex: 0,
      typeIndex: 0,
      searchModel: null,
      pageIndex: 1,
      size: 10,
      isLoading: false,
      tempText: '',
      ownSeachText: null,
      count: 0,
    }
  },
  computed: {
    searchText() {
      if (this.ownSeachText == null) {
        let searchText = this.$route.params.searchText;
        if (searchText != undefined) {
          searchText = decodeURI(searchText);
          this.ownSeachText = searchText;
        } else {
          this.ownSeachText = '';
        }
      }
      return this.ownSeachText;
    },

    userList() {
      return this.searchModel.users == null ? [] : this.searchModel.users;
    },
    activityList() {
      return this.searchModel.activities == null ? [] : this.searchModel.activities;
    },

    userCount() {
      return this.searchModel.userCount;
    },

    activityCount() {
      return this.searchModel.activityCount;
    },

    // count() {
    //   return this.activityCount > this.userCount ? this.activityCount : this.userCount;
    // },

    totalPage() {
      let total = 0;
      if (this.count == 0) {
        total = 0;
      } else {
        total = Math.ceil(this.count / this.size);
      }
      return total;
    }
  },
  mounted() {
    // console.log('加载');
    this.tempText = this.searchText;
    if (this.tempText != '') {
      this.loadData();
    }
  },
  updated() {
    // console.log('页面刷新');
  },
  methods: {
    searchButtonClicked() {
      let searchText = this.tempText.removeBlanks();
      if (searchText == this.ownSeachText) {
        return;
      }
      if (searchText == '') {
        return;
      }
      // this.ownSeachText = null;
      GlobalInstance.search.refreshSearchPage(this.$router, searchText);
    },

    userHeadIcon(user) {
      let headPortrait = user.headPortrait;
      if (headPortrait != null && headPortrait.length > 0) {
        return headPortrait;
      }

      if (user.isMember == 1) {

        if (user.isTeam == 1) {
          return GroupGoldDefaultHeadIcon;
        } else {
          return PersonGoldDefaultHeadIcon;
        }
      } else {
        if (user.isTeam == 1) {
          return GroupRedDefaultHeadIcon;
        } else {
          return PersonRedDefaultHeadIcon;
        }
      }

    },

    userItemSrc(user) {
      return '/introduce/0203/detail/' + user.id;
    },

    itemDate(item) {
      return this.$moment(item.createTime).format('yyyy.MM.DD');
    },

    itemSrc(item) {
      let web = item.newsUrl;
      if (web != null && web.length > 0) {
        return web;
      }
      return '/news/0301/0/' + item.id;
    },

    filterSearchText(context) {
      let searchText = this.searchText;
      if (searchText == null) {
        return context;
      }

      let patt = new RegExp(searchText, 'g');
      let replaceText = "<span style='color: #fc1a34;font-weight: bold;'>" + searchText + "</span>"
      let temp = context.replace(patt, replaceText);
      return temp;
    },
    dateFilterMenuClicked(index) {
      if (this.isLoading) {
        return;
      }
      this.dateIndex = index;
      this.pageIndex = 1;
      this.loadData();
    },
    typMenuClicked(index) {
      if (this.isLoading) {
        return;
      }
      this.typeIndex = index;
      this.pageIndex = 1;
      this.loadData();
    },

    loadData() {
      if (this.isLoading) {
        return;
      }

      let searchText = this.tempText.removeBlanks();
      if (searchText == '') {
        return;
      }

      let pageIndex = this.pageIndex;
      let duration = this.dateFilterList[this.dateIndex].duration;
      let type = this.typeFilterList[this.typeIndex].tag;
      let isTeam = -1;
      if (type < 0) {
        if (type == -1) {
          isTeam = 0;
        } else if (type == -2) {
          isTeam = 1;
        }
        type = 0;
      }
      let params = {
        isTeam,
        keyword: searchText,
        duration,
        type,
        pageIndex,
        size: this.size,
      };
      // console.log(params);
      let _this = this;
      this.isLoading = true;
      this.$store.state.http.ajax.vmSearch(params, function (data) {
        _this.isLoading = false;
        // console.log(data);
        let code = data.code;
        if (code == 0) {
          _this.searchModel = data.data;
          _this.count = data.count;
          return;
        }

        _this.$toast('请求失败！');

      }, function (data) {
        _this.isLoading = false;
        _this.$toast('请求失败，请重试');
      })

    },

    leftButtonClicked() {
      let index = this.pageIndex;
      index --;
      if (index >= 1) {
        this.pageIndex = index;
        this.loadData();
      }
    },
    rightButtonClicked() {
      let index = this.pageIndex;
      index ++;
      if (index <= this.totalPage) {
        this.pageIndex = index;
        this.loadData();
      }
    },
    pageButtonClicked() {
      this.loadData();
    }
  }


}
</script>

<style scoped>
  #search_page_outer {
    padding-bottom: 50px;
  }

  #top_search_outer {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    margin-top: 30px;

  }

  #search_top_input {
    outline: none;
    border: solid 1px #fc1a34;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    font-size: 1.2rem;
    height: 45px;
    text-indent: 15px;
    width: 20%;
    min-width: 200px;
  }

  #top_search_button {
    color: white;
    background-color: #fc1a34;
    display: block;
    height: 45px;
    line-height: 45px;
    padding: 0 20px;
    border: solid 1px #fc1a34;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    text-align: center;
    font-size: 2rem;
    color: white;
    text-decoration: none;
  }

  #top_search_button:hover {
    color: #eee;
  }


  #search_content_outer {
    margin-top: 30px;
  }

  #search_date_selector_outer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }

  #search_date_selector_outer > a {
    color: #333;
    font-size: 1rem;
    padding: 8px 0px;
    width: 70px;
    border: solid 1px #fc1a34;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    display: inline-block;
    border-bottom: none;
    text-decoration: none;
    text-align: center;
  }

  #search_date_selector_outer > a:not(:last-child) {
    margin-right: 1px;
  }

  #search_date_selector_outer > a:hover, #search_date_selector_outer > a.active {
    color: white;
    background-color: #fc1a34;
  }
  #search_date_selector_outer > a.active {
    pointer-events: none;
  }

  #search_type_selector_outer {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    border: solid 1px #fc1a34;
    border-bottom: none;

  }

  #search_type_selector_outer > a {
    display: inline-block;
    text-decoration: none;
    color: #333;
    font-size: 1rem;
    text-align: center;
    padding: 8px 30px;
    letter-spacing: 2px;
  }

  #search_type_selector_outer > a.active, #search_type_selector_outer > a:hover {
    color: #fc1a34;
  }
  #search_type_selector_outer > a.active {
    pointer-events: none;
  }

  #search_result_outer {
    border: solid 1px #fc1a34;
    min-height: 300px;
    padding-bottom: 30px;
  }
  #search_result_outer ul {
    min-height: 300px;
  }


  #search_result_outer li {
    border: none;
  }

  #search_result_outer .search-item-user {
    background-color: #cbb042;
    width: 100%;
    min-width: 250px;
    padding: 10px;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    padding-left: 15px;
    padding-right: 15px;
  }





  #search_result_outer .search-item-user .user-header {
    width: 80px;
    height: 80px;
    border-radius: 40px;
    overflow: hidden;
    display: flex;
    align-items: center;
  }

  #search_result_outer .search-item-user .user-header > img {
    margin: auto;
    max-width: 100%;
    height: auto;
  }



  #search_result_outer .search-item-info {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    font-size: 1rem;
    color: #333;
  }

  #search_result_outer .user-content {
    color: white;
    font-size: 1rem;
    margin-left: 5%;
    font-weight: bold;
  }

  .user-content div:last-child {
    margin-top: 10px;
  }


  #search_result_bottom_paginator a {
    color: #fc1a34;
    font-size: 1.5rem;
    text-decoration: none;
  }

  #search_result_bottom_paginator a:hover {
    color: #999;
  }

  #search_result_bottom_paginator a:visited {
    color: #fc1a34;
  }

  #search_result_bottom_paginator > span {
    color: #333;
    font-size: 1.5rem;
  }

  #search_result_outer .search-user-outer {
    /*background-color: red;*/
  }


  @media screen and (min-width: 768px){
    #search_result_outer {
      /*padding: 30px 4vw;*/
    }

    #search_result_outer .search-item-user {
      /*width: 60%;*/
    }

    #search_date_selector_outer > a {
      width: 100px;
    }
  }



</style>



// WEBPACK FOOTER //
// src/pages/SearchPage.vue